import React from "react";
import SRCLogo from "../../assets/headings/src.svg";
import HowInvolved from "../../assets/headings/how-to-get-involved.svg";
import HowFitIn from "../../assets/headings/how-src-fits.svg";
import WhatIsIt from "../../assets/headings/what-is-src.svg";
import SRCTopics from "../../assets/headings/src-topics.svg";
import { SectionProps } from "../../App";
import { getCourseContent } from "../../data/courseContent";
import {
  handleAnchorClick,
  lectureAt,
} from "../../data/lectureAnchors";
import "./SRC.scss";

const FIT_ITEMS = [
  "Mini-assignments",
  "Lab activities tied to lecture",
  "Two extra-credit discussions (TBA)",
];

const INVOLVED = [
  {
    title: "Groups @ Brown",
    items: [
      "SRC Reading group: ARG@Brown",
      "AIRES (AI Robotics Ethics Society)",
      "Human Centered Robotics Initiative",
      "Design for America @ Brown",
    ],
  },
  {
    title: "Alum-founded & others",
    items: [
      "Better World by Design",
      "Impact Labs",
      "Coding it Forward",
      "TechCongress",
    ],
  },
  {
    title: "Classes @ Brown",
    items: [
      "CSCI 1870: Cybersecurity Ethics",
      "CSCI 1951I: CS for Social Change",
      "DATA 0080: Data, Ethics and Privacy",
      "MCM 0230: Digital Media",
      "PHIL 0401: Ethics of Digital Technology",
      "STS 1700T: Race, Gender, and Technology",
      "More in Science, Technology, and Society",
    ],
  },
];

export class SRC extends React.Component<SectionProps> {
  render() {
    const { srcTopics } = getCourseContent();
    return (
      <section id="src" className={`src ${this.props.static ? "static" : ""}`}>
        <div className="src-shell">
          <div className="section-heading">
            <img className="src-logo logo" src={SRCLogo} alt="src text" />
          </div>

          <div className="src-top">
            <article className="src-panel">
              <img className="src-subhead" src={WhatIsIt} alt="What is SRC?" />
              <p>
                As awareness of technology’s consequences grows, attention turns
                to how computer scientists are trained. Brown’s Socially
                Responsible Computing initiative, started in 2019, weaves ethics
                and social impact into most major CS courses. In CS15 we give
                you a broad look at today’s technological landscape so those
                ideas are familiar when you later make ethical design decisions.
              </p>
              <img
                className="src-subhead src-subhead--follow"
                src={HowFitIn}
                alt="How SRC fits in the CS15 curriculum"
              />
              <ul className="src-fit">
                {FIT_ITEMS.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>

            <article className="src-panel">
              <img
                className="src-subhead"
                src={HowInvolved}
                alt="How to get involved"
              />
              <div className="src-involved">
                {INVOLVED.map((column) => (
                  <div className="src-involved-col" key={column.title}>
                    <h3>{column.title}</h3>
                    <ul>
                      {column.items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </article>
          </div>

          <div className="src-topics-head">
            <img
              className="src-subhead"
              src={SRCTopics}
              alt="Topics in socially responsible computing"
            />
          </div>
          <div className="src-topics">
            {srcTopics.map((topic) => (
                <article className="src-topic" key={topic.title}>
                  <h3>{topic.title}</h3>
                  <ul className="src-topic-lectures">
                    {topic.lectures.map((lectureNumber) => {
                      const lecture = lectureAt(lectureNumber);
                      return (
                        <li key={lectureNumber}>
                          <a
                            href={`#${lecture.id}`}
                            onClick={(event) => handleAnchorClick(event, lecture.id)}
                            title={lecture.title}
                          >
                            Lecture {lectureNumber}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </article>
            ))}
          </div>
        </div>
      </section>
    );
  }
}
